<div class="modal-container">
        <div mat-dialog-title
             class="modal-header">
                <h1 class="modal-title">{{data.title}}</h1>
        </div>
        <div mat-dialog-content
             class="modal-content">
                <div class="message-container">
                  <div class="warn-message" *ngIf="data.warning">{{data.warning}}</div>
                  <div class="main-message" *ngIf="data.message">{{data.message}}</div>
                </div>
        </div>
        <div mat-dialog-actions
             *ngIf="isOkOnlyButton"
             class="modal-toolbar commands">
                <button mat-button
                        class="datex-button primary"
                        (click)="onConfirm()">OK</button>
        </div>
        <div mat-dialog-actions
             *ngIf="isOkCancelButton"
             class="modal-toolbar commands">
                <button mat-button
                        class="datex-button primary"
                        (click)="onConfirm()">OK</button>
                <button mat-button
                        class="datex-button secondary"
                        (click)="onDismiss()">Cancel</button>
        </div>
        <div mat-dialog-actions
             *ngIf="isYesNoButton"
             class="modal-toolbar commands">
                <button mat-button
                        class="datex-button primary"
                        (click)="onConfirm()">Yes</button>
                <button mat-button
                        class="datex-button secondary"
                        (click)="onDismiss()">No</button>
        </div>
</div>